import { render, staticRenderFns } from "./EventModal.vue?vue&type=template&id=11debecd&scoped=true"
import script from "./EventModal.vue?vue&type=script&lang=js"
export * from "./EventModal.vue?vue&type=script&lang=js"
import style0 from "./EventModal.vue?vue&type=style&index=0&id=11debecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11debecd",
  null
  
)

export default component.exports